import React from "react"
import Slider from "@components/Slider/Slider";

const Latest = ({ config }) => {
  const latestUrl = "/api/digital_items/latest/"
  return <Slider config={config} url={latestUrl} />;
}

export default Latest;
